
import { computed, defineComponent, PropType, ref, getCurrentInstance} from "vue";
import { Customer } from "@/models/Customer";
import { MemberApi } from "@/services/Api";
import { useAsyncSpinner } from "@/services/Spinner";
import BaseButton from "@/components/BaseButton.vue";
import { AxiosResponse } from "axios";
import UpdateModelHelper from "@/helpers/Helpers";

export default defineComponent({
  components: {
      BaseButton
  },
  props: {
    title: {
      type: String,
      required: false
    },
    source: {
      type: Object as PropType<Customer>,
      required: true
    },
    shipTo: {
      type: Boolean,
      required: false,
      default: false
    },
    buyer: {
      type: Boolean,
      required: false,
      default: false
    },
    payer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const customer = ref<Customer>(props.source);

    const updateModel = UpdateModelHelper.createUpdateModel(customer.value);

    const errorMessage = ref<string | AxiosResponse>();
    const hasError = computed<boolean>(() => !errorMessage.value && errorMessage.value !== "");
    const successMessage = ref<string | AxiosResponse>();
    const success = ref(false);
    const vm = getCurrentInstance();

    const onSubmit = async() => {
      successMessage.value = "";
      errorMessage.value = "";
      success.value = false;
      
      await useAsyncSpinner(async () => {
        if(!updateModel.line1) {
          errorMessage.value = vm?.proxy?.$t('UpdateError.Line1');
          return;
        }

        if(!updateModel.zip) {
          errorMessage.value = vm?.proxy?.$t('UpdateError.Zip');
          return;
        }

        if(!updateModel.city) {
          errorMessage.value = vm?.proxy?.$t('UpdateError.City');
          return;
        }

        if(!updateModel.country) {
          errorMessage.value = vm?.proxy?.$t('UpdateError.Country');
          return;
        }

        const model = await MemberApi.updateCustomer(updateModel);

        if (model.success) {
          success.value = true;
          successMessage.value = model.message;

          window.location.reload()
        } else {
          errorMessage.value = model.message;
        }
      });
    };

    return {
      customer,
      updateModel,
      errorMessage,
      hasError,
      successMessage,
      success,
      onSubmit
    };
  },
  methods: {
    validatePhone(value) {
      if (!value) {
        return true;
      }

      const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
      return regex.test(value);
    }
  }
});
